/**
 * src/db/directory.db.js
 *
 * Datos de la sección Directorio de negocios y servicios.
 */

export const directoryData = {
    section: {
        headline:    'Directorio de negocios y servicios en Fusagasugá',
        description: 'Explora categorías locales y encuentra negocios, productos y servicios disponibles en Fusagasugá de forma rápida y organizada.'
    },
    categories: [
        { id:  1, icon: '🍽️', name: 'Restaurantes',          count: 24, slug: 'restaurantes'          },
        { id:  2, icon: '☕',  name: 'Cafés',                 count: 24, slug: 'cafes'                 },
        { id:  3, icon: '💄',  name: 'Belleza',               count: 24, slug: 'belleza'               },
        { id:  4, icon: '🏥',  name: 'Salud',                 count: 24, slug: 'salud'                 },
        { id:  5, icon: '🛍️', name: 'Tiendas',               count: 24, slug: 'tiendas'               },
        { id:  6, icon: '👗',  name: 'Moda',                  count: 24, slug: 'moda'                  },
        { id:  7, icon: '🔧',  name: 'Ferreterías',           count: 21, slug: 'ferreterias'           },
        { id:  8, icon: '🐾',  name: 'Mascotas',              count: 18, slug: 'mascotas'              },
        { id:  9, icon: '📚',  name: 'Educación',             count: 21, slug: 'educacion'             },
        { id: 10, icon: '💼',  name: 'Servicios profesionales',count: 29, slug: 'servicios-profesionales'},
        { id: 11, icon: '💻',  name: 'Tecnología',            count: 39, slug: 'tecnologia'            },
        { id: 12, icon: '🚗',  name: 'Transporte',            count: 39, slug: 'transporte'            },
        { id: 13, icon: '🏋️', name: 'Gimnasios',             count: 11, slug: 'gimnasios'             },
        { id: 14, icon: '🏨',  name: 'Hoteles',               count: 18, slug: 'hoteles'               },
        { id: 15, icon: '🎉',  name: 'Eventos',               count: 10, slug: 'eventos'               },
        { id: 16, icon: '🎭',  name: 'Entretenimiento',       count: 10, slug: 'entretenimiento'       },
        { id: 17, icon: '🚘',  name: 'Automotores',           count: 10, slug: 'automotores'           },
        { id: 18, icon: '🔩',  name: 'Repuestos',             count: 21, slug: 'repuestos'             }
    ]
}
